<template>
<div>
    <b-form>
        <b-row>
            <b-col class="col-lg-4 mt-1">
                <div>
                    <label for="change-two-factor-authentication-status-input">{{ $t('changeTwoFactorAuthentication.status') }}</label>
                    <div class="d-flex flex-column">
                        <b-form-checkbox class="custom-control-success" name="change-two-factor-authentication-status-input" id="change-two-factor-authentication-status-input" v-model="twoFactorAuthStatus" switch>
                            <span class="switch-icon-left">
                                <feather-icon icon="CheckIcon" />
                            </span>
                            <span class="switch-icon-right">
                                <feather-icon icon="XIcon" />
                            </span>
                        </b-form-checkbox>
                    </div>
                </div>
            </b-col>
            <b-col class="col-lg-4 mt-1">
                <label for="change-two-factor-authentication-employee-count">{{ $t('changeTwoFactorAuthentication.count_of_employee') }}</label>
                <b-form-input id="change-two-factor-authentication-employee-count" v-model="count" size="sm" type="number" :disabled="true" />
            </b-col>
            <b-col class="col-lg-4 mt-1">
                <div class="demo-inline-spacing d-flex justify-content-end">
                    <b-button variant="outline-primary" size="sm" @click.prevent="changeTwoFactorAuthentication">
                        {{ $t('changeTwoFactorAuthentication.save_status') }}
                    </b-button>
                </div>
            </b-col>
        </b-row>

    </b-form>
</div>
</template>

<script>
export default {
    data() {
        return {
            id: 0,
            twoFactorAuthStatus: false,
            count: 0,
        }
    },
    computed: {},
    mounted() {
        this.get2FAStatusForEmployees()
    },
    methods: {
        changeTwoFactorAuthentication() {
            const controller = {
                name: 'Employee',
                actionName: 'Change2FACheckForEmployees'
            }
            const data = {
                status: this.twoFactorAuthStatus
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
            this.get2FAStatusForEmployees()
            loader.hide()

        },
        get2FAStatusForEmployees() {
            const controller = {
                name: 'Employee',
                actionName: 'Get2FAStatusForEmployees'
            }
            const data = {}
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customServiceGet', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.twoFactorAuthStatus = response.data.is2FAEnabled
                    this.count = response.data.countOfEmployeesWithThat2FAStatus
                }
            })
            loader.hide()
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
